var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.706 34.292L28.024 26.611C29.4634 24.8102 30.1585 22.5267 29.9667 20.2294C29.7748 17.932 28.7106 15.7954 26.9925 14.2583C25.2744 12.7212 23.0329 11.9004 20.7285 11.9644C18.4241 12.0284 16.2317 12.9724 14.6016 14.6025C12.9715 16.2326 12.0275 18.425 11.9634 20.7295C11.8994 23.0339 12.7203 25.2753 14.2574 26.9934C15.7944 28.7115 17.9311 29.7758 20.2284 29.9676C22.5257 30.1595 24.8093 29.4643 26.6101 28.025L34.292 35.706C34.3843 35.8015 34.4946 35.8777 34.6166 35.9301C34.7386 35.9825 34.8699 36.0101 35.0026 36.0112C35.1354 36.0124 35.2671 35.9871 35.39 35.9368C35.5129 35.8865 35.6246 35.8123 35.7184 35.7184C35.8123 35.6245 35.8866 35.5128 35.9369 35.39C35.9872 35.2671 36.0125 35.1354 36.0113 35.0026C36.0101 34.8698 35.9826 34.7386 35.9302 34.6166C35.8777 34.4946 35.8016 34.3842 35.706 34.292ZM14.0001 21C14.0001 19.6155 14.4106 18.2622 15.1798 17.111C15.9489 15.9599 17.0422 15.0627 18.3213 14.5328C19.6003 14.003 21.0078 13.8644 22.3657 14.1345C23.7235 14.4046 24.9708 15.0713 25.9498 16.0503C26.9288 17.0292 27.5955 18.2765 27.8655 19.6344C28.1356 20.9922 27.997 22.3997 27.4672 23.6788C26.9374 24.9579 26.0402 26.0511 24.889 26.8203C23.7379 27.5895 22.3845 28 21.0001 28C19.1442 27.9979 17.3649 27.2597 16.0526 25.9474C14.7403 24.6351 14.0022 22.8559 14.0001 21Z",
    fill: "#072B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20H17.5C17.2348 20 16.9804 20.1054 16.7929 20.2929C16.6054 20.4804 16.5 20.7348 16.5 21C16.5 21.2652 16.6054 21.5196 16.7929 21.7071C16.9804 21.8946 17.2348 22 17.5 22H24.5C24.7652 22 25.0196 21.8946 25.2071 21.7071C25.3946 21.5196 25.5 21.2652 25.5 21C25.5 20.7348 25.3946 20.4804 25.2071 20.2929C25.0196 20.1054 24.7652 20 24.5 20Z",
    fill: "#0397AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.3de07d6b0fa675e408de825cfee8c925.svg";
export { ForwardRef as ReactComponent };